module.exports = __webpack_public_path__ + "025bb26c8347c8568b950abe3379a8c8.pdf";